module.exports = __webpack_public_path__ + "img/icon-darkness-ax-dark.840487ef.svg";